var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLayout',{attrs:{"showNavBar":true,"pageTitle":"Profilo personale"},scopedSlots:_vm._u([{key:"page-content",fn:function(){return [_c('UserProfile')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }